<form
  *transloco="let t; prefix: 'common'"
  data-testid="provider-registration-form"
  [formGroup]="theForm"
  (ngSubmit)="onSubmit()"
  class="flex flex-col gap-4"
>
  <div class="grid grid-cols-2 gap-4">
    <app-form-field
      id="street"
      fieldName="street"
      label="common.street"
      type="text"
    ></app-form-field>

    <app-form-field
      id="housenumber"
      fieldName="houseNumber"
      label="common.houseNumber"
      type="text"
    ></app-form-field>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <app-form-field
      id="zipCode"
      fieldName="zipCode"
      label="common.zipCode"
      type="text"
    ></app-form-field>

    <app-form-field id="city" fieldName="city" label="common.city" type="text"></app-form-field>
  </div>

  <div class="flex flex-col gap-2">
    <label for="countryCode">{{ 'common.country' | transloco }}</label>
    <app-country-select
      formControlName="countryCode"
      [placeholder]="'common.country' | transloco"
      testId="countryCode-input"
    ></app-country-select>
    @if (theForm.get('countryCode')?.invalid && theForm.get('countryCode')?.touched) {
      <p-message severity="error" variant="simple" size="small" data-testid="countryCode-error">
        {{ 'account.validation.requiredField' | transloco }}
      </p-message>
    }
  </div>

  <app-form-field
    id="tenderContactEmail"
    fieldName="tenderContactEmail"
    label="providerData.tenderContactEmail"
    type="email"
  ></app-form-field>

  <app-form-field
    id="salesTaxNumber"
    fieldName="salesTaxNumber"
    label="providerRegister.salesTaxNumber"
  ></app-form-field>

  <div class="mt-4">
    <p-button
      data-testid="provider-register-button"
      type="submit"
      [label]="t('save')"
      [loading]="isSaving()"
      [disabled]="theForm.invalid || isSaving()"
    ></p-button>
  </div>
</form>
